import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export const useStyles = makeStyles(() => ({
  minimizedColumnContainer: {
    padding: '6px 4px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    height: '100%',
  },
  minimizedToggleButton: {
    minWidth: '20px',
    width: '20px',
    height: '20px',
    padding: 0,
    fontSize: '14px',
    textDecoration: 'none',
  },
  minimizedColumnTitle: {
    fontWeight: 700,
    fontSize: '14px',
    writingMode: 'vertical-rl',
    textOrientation: 'mixed',
    textAlign: 'center',
    lineHeight: '1.2',
  },
  minimizedColumnCount: {
    marginTop: '12px',
    color: Theme.Colors.Grayscale.SixtyFour,
    fontWeight: 600,
    fontSize: '12px',
  },
  normalColumnContainer: {
    padding: '4px 8px',
    display: 'flex',
    flexDirection: 'column',
  },
  normalColumnHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '4px',
  },
  normalColumnTitle: {
    fontWeight: 700,
  },
  normalToggleButton: {
    minWidth: '24px',
    width: '24px',
    height: '24px',
    padding: 0,
    textDecoration: 'none',
  },
  normalColumnCount: {
    fontSize: 12,
    color: Theme.Colors.Grayscale.SixtyFour,
  },
}))

export const MINIMIZE_BUTTON_STYLE = {
  minWidth: '20px',
  width: '20px',
  height: '20px',
  padding: 0,
  fontSize: '16px',
  textDecoration: 'none',
}
